<!-- Dashboard -->
<script>
import Store from "../shared/components/store/store";
import axios from "axios";
import Loader from "../shared/components/loader/loader.vue";
import Errors from "../shared/components/errors-page/errors.vue";
import StoreFooterMobile from "../shared/components/store-footer-mobile/store-footer-mobile.vue";
export default {
  data() {
    return {
      networkError: false,
      error: false,
      error401: false,
      error500: false,
      errorOther: false,
      search: "",
      stores: [],
      isLoading: true,
    };
  },
  components: {
    Store,
    Loader,
    Errors,
    StoreFooterMobile
  },
  methods: {
    backPage () {
      this.$router.push({name: 'Profile'})
    },
    nextPage(code, name) {
      if (this.$store.state.storeName !== name) {
        this.$store.commit('updateSelectedManagers', [])
        this.$store.commit('updateAssingedManagers', {})
      }
      this.$router.push(`/assign/select-manager/${code}`);
      this.$store.commit("changeStoreName", name);
    },
    goToHomePage () {
      window.parent.location.href = this.$store.getters.domain;
    }
  },
  created() {
    if (navigator.onLine) {
      this.networkError = false;
      this.error = false;
    } else {
      this.error = true;
      this.networkError = true;
    }
    const code = this.$store.state.code
    axios
      .post(
        `${process.env.VUE_APP_API_URL}/Orgnodes/getHierarchy`,
        {
          code: code
        },
        { withCredentials: true }
      )
      .then((res) => {
        this.$store.commit("updatePointRate", res.data.pointBillingRate)
        this.$store.commit("updateCurrenct", res.data.defaultOperatingCurrencyCode)
        this.stores = res.data.children;
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response !== undefined) {
          if (error.response.data.error.status === 401) {
            this.error = true;
            this.error401 = true;
          } else if (error.response.data.error.status === 500) {
            this.error = true;
            this.error500 = true;
          } else {
            this.error = true;
            this.errorOther = true;
          }
        } else {
          this.error = true;
          this.errorOther = true;
        }
      });
  },
  computed: {
    filteredList() {
      if (this.search) {
        return this.stores.filter((post) => {
          return post.name.toLowerCase().includes(this.search.toLowerCase());
        });
      } else {
        return this.stores;
      }
    },
    noStoreData() {
      return this.filteredList.length > 0;
    },
    selectStoreTitle () {
      return process.env.VUE_APP_SELECT_STORE_MSG || this.$t('message.select')
    }
  },
  name: "dashboard",
};
</script>

<!-- Template -->
<template>
  <fragment>
    <div v-if="!error" class="button-container container-fluid">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-md-12 offset-md-0">
          <b-row class="margin-bt-24">
            <b-col lg="6" md="7" sm="12" class="select-store-header">
              <b-button
                @click="backPage"
                class="back-button btn-ripple back-button-width hide-on-mob"
                variant="outline-light"
              >
                <img class="arrow" src="../../assets/arrow.svg" alt />
                {{ $tc("message.backAndNext", 1) }}
              </b-button>
              <h2 class="dashboard-title m-0">{{ selectStoreTitle }}</h2>
            </b-col>
            <b-col lg="6" md="5" sm="12">
              <div>
                <b-form-input
                  class="search-store"
                  v-model="search"
                  :placeholder="$tc('message.searchplaceholder', 1)"
                ></b-form-input>
              </div>
            </b-col>
          </b-row>
          <div class="store-container">
            <b-row v-if="isLoading === false && noStoreData">
              <b-col
                class="p-lr-12"
                v-for="store in filteredList"
                :key="store.id"
                lg="4"
                md="6"
                sm="6"
                @click="nextPage(store.code, store.name)"
              >
                <store :store="store"></store>
              </b-col>
            </b-row>
            <!--No Data Message Start-->
            <div class="no-data-wrapper" v-else-if="isLoading === false && !noStoreData">
              <img
                class="alertimg"
                src="../../assets/alert.svg"
                alt
              />
              <p class="no-data-title mb-0 mt-3">{{ $t("message.noStoreMessage") }}</p>
              <b-button
                @click="goToHomePage()"
                class="another-page-button next-button-color btn-ripple mt-4 mx-auto"
                variant="light"
                >{{$t('message.goToHomePage')}}</b-button
              >
            </div>
            <!--No Data Message Ends-->
            <loader v-if="isLoading === true"></loader>
            <store-footer-mobile
              class="mobileVisible"
              @back="backPage"
              info="no"
              nextbtn="no"
              disabled=""
            ></store-footer-mobile>
          </div>
        </div>
      </div>
    </div>
    <errors
      v-else
      :errorNetworkrErrorprops="this.networkError"
      :error401props="this.error401"
      :error500props="this.error500"
      :errorOtherprops="this.errorOther"
    ></errors>
  </fragment>
</template>

<!-- Style -->
<style lang="scss" scoped>
.store-container {
  background: #f8f8f8;
  border-radius: 5px;
  border: none;
  padding: 24px;
  overflow: auto;
  max-height: 77.3vh;
  height: 77.3vh;
}
.store-container .row {
  margin-left: -12px;
  margin-right: -12px;
}

.dashboard-title {
  font-style: normal;
  font-weight: bold;
  color: #333;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.1px;
}
.search-store {
  float: right;
  width: 329px;
  height: 48px;
  border-radius: 5px;
  background: #ffffff;
  background-blend-mode: multiply;
  border: 1px solid #c1c8cf;
  background-image: url("../../assets/search.svg");
  background-position: 12px 12px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
}

.search-store::placeholder {
  color: #c1c8cf;
}
.search-store:focus {
  border: 2px solid #c1c8cf;
}
.alertimg{
    width: 30.67px;
    height: 30.67px;
    border-radius: 50%;
    top: 2.08%;
    bottom: 2.08%;
}
.no-data-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70.0vh;
}
.no-data-title {
  font-style: normal;
  font-weight: 500;
  color: #45505B;
  font-size: 16px;
  letter-spacing: 0.1px;
  text-align: center;
}
.go-to-homepage-button {
  min-width: 297px;
  padding: 12px;
  border-radius: 5px;
  border: 1px solid;
  background: #F8F8F8;
  text-align: center;
  font-weight: 500;
}

@media (max-width: 600px) {
  .store-container {
    background: #fff;
    padding: 0px;
    height: 75vh;
    margin-left: -15px;
    margin-right: -15px;
  }
  .search-store {
    width: 100%;
    margin-top: 5px;
  }
  .dashboard-title {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  .store-container .row {
    margin: 0px;
  }
}

@media (min-width: 601px) and (max-width: 767px) {
  .dashboard-title {
    font-size: 22px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .dashboard-title {
    font-size: 22px;
  }
}
@media (max-width: 1200px) {
  .search-store {
    width: 100%;
  }
}
@media (min-width: 768px) {
  .p-lr-12 {
    padding-left: 12px;
    padding-right: 12px;
  }
}
.select-store-header {
  display: flex;
  align-items: center;
}
.back-button-width {
  max-width: 100px;
}
</style>